import {type HopperConfig} from '@/api/hopper-configs';

// Hoppers are unique on (policy_violation, submission_type): a policy violation can carry a
// separate Actor and Content hopper, each with its own delivery target, batch size and schedule.
// Matching on the policy violation alone picks whichever row came back first, so a Content
// selection could be fired down the Actor hopper. Every server-side caller matches on both columns
// (HopperSendRunnerService, ClassificationWriter, QcReviewController) - match them.
//
// Its own file rather than living in SubmissionsWorkspace.tsx: both the table's action menu and the
// bulk-selection bar need it, and having either import it from the other would be circular.
export function findHopperConfig(
  hopperConfigs: readonly HopperConfig[],
  policyViolation: string,
  submissionType: 'Actor' | 'Content'
): HopperConfig | null {
  return (
    hopperConfigs.find(
      (h) =>
        h.policy_violation === policyViolation &&
        h.submission_type === submissionType &&
        h.is_deliverable
    ) ?? null
  );
}
